(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ileara-email-popup"]) return;
  try {
    
(function() {
  var dialog = document.querySelector('[data-ileara-email-popup]');
  if (!dialog || typeof dialog.showModal !== 'function' || window.Shopify && Shopify.designMode) return;
  var key = 'ileara-email-popup-seen';
  var error = dialog.querySelector('[data-ileara-popup-error]');
  var success = dialog.querySelector('[data-ileara-popup-success]');
  var show = function() { if (!dialog.open) dialog.showModal(); };
  if (success) { sessionStorage.setItem(key, '1'); return; }
  if (error) show();
  else if (!sessionStorage.getItem(key)) window.setTimeout(show, 12000);
  dialog.addEventListener('close', function() { sessionStorage.setItem(key, '1'); });
  var close = dialog.querySelector('[data-ileara-email-close]');
  if (close) close.addEventListener('click', function() { dialog.close(); });
  var form = dialog.querySelector('form');
  if (form) form.addEventListener('submit', function() { sessionStorage.setItem(key, '1'); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
